import React, {useEffect, useState} from 'react';
import { Modal } from 'antd';
import axios from '../Common/axios';
import InfoTable from './InfoTable';
import {threatColumnData} from './columns';
import {getFindInfoThreatListData, postSaveVaThreatData} from '../Common/api';

function InfoThreat({reportId, reportInfo}) {

    const [companyCode, setCompanyCode] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    const titleName="위협 등록";

    useEffect(() => {
        //자동조회
        if(reportId) {
            findInfoThreatListData();
        }
    }, []);

    useEffect(() => {
        if(reportInfo) {
            setCompanyCode(reportInfo.com_cd);
        }
    }, [reportInfo]);

    function convertNewlines(obj) {
        let str = obj[1];
        if(typeof str === 'string'){
            str = str.replace(/\\\\n/g, '<br/>');
            str = str.replace(/\\n/g, '<br/>');
        }
        return str;
    }

    const findInfoThreatListData = () => {
        // 보고서ID 필수조건 체크
        if (reportId == '') {
            Modal.info({title:titleName, content:"Report ID가 누락 되었습니다."});
            return;
        }

        setIsLoading(true);
        setIsDataChange(false);
        axios.get(getFindInfoThreatListData(reportId))
            .then((response) => {
                //console.log(response);
                setIsLoading(false);
                setDataSource(response.data);
                //if(response.data.totalCount == 0) {
                //    Modal.info({title: "조회된 결과가 없습니다.", okText:"닫기"});
                //} 
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {

        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveCheckList(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

    }

    // 등록/수정/삭제 API
    const saveCheckList = (saveData) => {

        setIsDataChange(false);
        axios.post(postSaveVaThreatData()
                        , {reportId : reportId, saveData : saveData}
                        , {logCompany : companyCode, logParam : reportId})
        .then((response) => {
            //console.log(response);
            //Modal.info({title: "OK.", okText:"Close"});

            if(response.data.message == '성공적으로 처리되었습니다.') {
                Modal.info({title:titleName, content:response.data.message, okText:"Close"});
                //정상적으로 처리된 경우, 재조회
                setIsDataChange(true);
            } else {
                Modal.info({title:titleName, content:response.data, okText:"Close"});  
            }
        })
        .catch((error) => {
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });
    };

    // 정보 변경시 재조회
    useEffect(() => {
        if(isDataChange) {
            findInfoThreatListData();
        }
    }, [isDataChange]);

    // 팝업에서 업로드 후 재조회
    const onReloadHandler = () => {
        //재조회
        findInfoThreatListData();
    }
    /** -------------------------------------------------------------------------- **/

    return (
        <>
            <div className='tab_content'>
                 <InfoTable
                    data={dataSource} 
                    columnData={threatColumnData}
                    reportId={reportId}
                    reportInfo={reportInfo}
                    infoType={'threat'}
                    isLoading={isLoading} 
                    onClickSaveHandler={onClickSaveHandler}
                    onReloadHandler={onReloadHandler}
                    assetTypeOrg=""
                    rowIndex="id" />
            </div>
        </>
    );
}

export default InfoThreat;